/* EAR PLAN navigation — vanilla JS, no dependencies.
 * - Mobile menu: native <dialog> (focus trap, Esc, inert background come from the browser).
 * - Desktop submenus: toggle button + hover/focus (CSS); Esc closes; focus leaving the item closes.
 */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 1100px)');

  /* ---------- mobile menu ---------- */
  document.querySelectorAll('[data-ep-menu]').forEach((dialog) => {
    const openers = document.querySelectorAll(`[data-ep-menu-open][aria-controls="${dialog.id}"]`);
    const setExpanded = (value) => openers.forEach((b) => b.setAttribute('aria-expanded', String(value)));

    const open = () => {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      setExpanded(true);
    };
    const close = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      setExpanded(false);
    };

    openers.forEach((b) => b.addEventListener('click', open));
    dialog.querySelectorAll('[data-ep-menu-close]').forEach((b) => b.addEventListener('click', close));
    // click on the backdrop (the dialog element itself) closes the menu
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) close();
    });
    // Esc and native close
    dialog.addEventListener('close', () => setExpanded(false));
    // leaving the mobile layout while the menu is open
    DESKTOP.addEventListener('change', (e) => {
      if (e.matches && dialog.open) close();
    });
  });

  /* ---------- desktop submenus ---------- */
  const items = document.querySelectorAll('[data-ep-sub]');
  const setOpen = (item, value) => {
    item.classList.toggle('is-open', value);
    const toggle = item.querySelector('.ep-nav__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', String(value));
  };
  const closeAll = (except) => items.forEach((i) => i !== except && setOpen(i, false));

  items.forEach((item) => {
    const toggle = item.querySelector('.ep-nav__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      closeAll(item);
      setOpen(item, willOpen);
    });
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        setOpen(item, false);
        toggle.focus();
      }
    });
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) setOpen(item, false);
    });
  });
  document.addEventListener('click', (e) => {
    if (![...items].some((i) => i.contains(e.target))) closeAll();
  });
})();
